import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=75077b6c&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=75077b6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75077b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75077b6c')) {
      api.createRecord('75077b6c', component.options)
    } else {
      api.reload('75077b6c', component.options)
    }
    module.hot.accept("./resetPassword.vue?vue&type=template&id=75077b6c&scoped=true", function () {
      api.rerender('75077b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/resetPassword.vue"
export default component.exports